import { CircleQuestionMarkIcon } from '@che-ins-ui/icons/CircleQuestionMarkIcon';
import { WarnTriagleIcon } from '@che-ins-ui/icons/WarnTriagleIcon';
export const hintModalIcons = {
    alert: WarnTriagleIcon,
    hint: CircleQuestionMarkIcon,
};
